// DOC: https://vuex.vuejs.org/en/getters.html

import _ from 'lodash';

export default {
    appetites: state =>
        (state.subscriptionType
            ? state.orderable.product_groups.find(s => s.id === state.subscriptionType).appetites
            : []),
    orderableBaskets: (state) => {
        if (state.orderable.product_groups) {
            const subscriptionType = state.orderable.product_groups.find(
                s => s.id === state.subscriptionType,
            );
            if (subscriptionType) {
                return subscriptionType.variants;
            }
            return [];
        }
        return [];
    },
    subscriptionType: state => (state.orderable.product_groups ? state.orderable.product_groups.find(
        s => s.id === state.subscriptionType,
    ) : []),
    extras: state => state.orderable && state.orderable.extras,
    amounts: (state) => {
        const { baskets } = state;

        const monday = _.reduce(baskets.monday, (sum, n) => sum + n.kg, 0);
        const wednesday = _.reduce(baskets.wednesday, (sum, n) => sum + n.kg, 0);

        const amounts = {
            monday,
            wednesday,
        };
        return amounts;
    },
    groupedBaskets: (state) => {
        const { baskets } = state;

        return {
            monday: _.groupBy(baskets.monday, 'id'),
            wednesday: _.groupBy(baskets.wednesday, 'id'),
        };
    },
    groupedBasketsExtra: (state) => {
        const { basketExtra } = state;

        return {
            monday: _.groupBy(basketExtra.monday, 'id'),
            wednesday: _.groupBy(basketExtra.wednesday, 'id'),
        };
    },
    basketExtra: state => state.basketExtra,
    sortedBasketsMonday: (state) => {
        const baskets = _.cloneDeep(state.baskets.monday);
        return _.orderBy(baskets, 'id', 'asc');
    },
    sortedBasketsPeopleMonday: (state) => {
        const baskets = _.cloneDeep(state.basketPeople.monday);
        return _.orderBy(baskets, 'id', 'asc');
    },
    sortedBbasketsWednesday: (state) => {
        const baskets = _.cloneDeep(state.baskets.wednesday);
        return _.orderBy(baskets, 'id', 'asc');
    },
    sortedBasketsPeopleWednesday: (state) => {
        const baskets = _.cloneDeep(state.basketPeople.wednesday);
        return _.orderBy(baskets, 'id', 'asc');
    },
    allBaskets: state => _.flatMap(state.orderable.product_groups, 'variants'),
    people: state => state.people,
    baskets: state => state.baskets,
};



// WEBPACK FOOTER //
// ./static/js/Order/store/getters.js